import React, { useEffect, useState } from 'react';
import { mdiChevronRight, mdiChevronDoubleRight } from '@mdi/js';
import Icon from '@mdi/react';
import { makeApiCall } from '../../../helpers/utils';
import SvgIcon from '../../atoms/svg-icon';
import { BQLink } from '../../atoms/bqlink';
import Loaded from '../../atoms/loader';
import './beeps-card-widget.m.css';
import { isMobile } from 'react-device-detect';

const BeepsCardWidget = ({ storyPage, params }) => {
  const safeParams = params || '?src=beeps';
  const [cardObject, setCardObject] = useState({});
  const [isLoading, setLoading] = useState(true);
  const fallback_img =
    'https://media.assettype.com/bloombergquint/import/ndtv_profit_placeholder___english.png';
  useEffect(() => {
    const fetchMoreData = () => {
      makeApiCall(`/beeps/get-beeps-data`).then((response) => {
        if (response?.success) {
          const processedBeepsData = response?.beepsData?.slice(0, 1).map((beep) => {
            const link = beep.link || '';
            const [domain, ...pathParts] = link?.split('.com/');
            const share_url = pathParts?.length > 0 ? `/beeps/${pathParts.join('')}` : '';
            return {
              ...beep,
              share_url,
            };
          });
          setCardObject(processedBeepsData[0] || {});
          setLoading(false);
        }
      });
    };
    fetchMoreData();
  }, []);
  const points = cardObject?.highlights?.split('\r\n');
  return (
    <div styleName={storyPage ? 'beeps-widget widget-space' : 'beeps-widget'}>
      {isLoading && isMobile ? (
        <div styleName="loader">
          <Loaded />
        </div>
      ) : (
        <>
          <BQLink styleName="logo" href={`/beeps${safeParams}`}>
            <SvgIcon type="beeps_dark" width="92px" height="17px" source="image" />
            <Icon path={mdiChevronRight} size="32px" />
          </BQLink>
          <div styleName="card-section">
            <BQLink
              href={cardObject?.share_url + safeParams || `/beeps${safeParams}`}
              styleName="card"
            >
              <img
                src={cardObject?.thumb_image}
                alt="Beeps Img"
                styleName="card-image"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = fallback_img;
                }}
              />
              <h2 styleName="card-title" title={cardObject?.title}>
                {cardObject?.title}
              </h2>
              <div styleName="card-content">
                {points?.length === 1 ? (
                  <div styleName="para">{points[0]}</div>
                ) : (
                  <ul styleName="card-list">
                    {points?.map((paragraph, index) => (
                      <li key={index} styleName="card-desc">
                        <Icon path={mdiChevronDoubleRight} color="#267CF9" />
                        <span styleName="desc" title={paragraph}>
                          {paragraph}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </BQLink>
            <img src="/icons/beeps_border.svg" styleName="border" />
          </div>
          <BQLink href={`/beeps${safeParams}`} styleName="more-beeps">
            More Beeps
            <Icon path={mdiChevronRight} />
          </BQLink>
        </>
      )}
    </div>
  );
};
export default BeepsCardWidget;
